module.exports = __webpack_public_path__ + "img/warning-icon.d43385f6.svg";